import React, {useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import * as dayjs from 'dayjs'
import * as utc from 'dayjs/plugin/utc'
import * as timezone from 'dayjs/plugin/timezone'
import * as relativeTime from 'dayjs/plugin/relativeTime'
import {useSolv} from "./components/SolvProvider"
import {useIntlEx} from "./components/IntlUtils.js"
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {ActionButton, Alert, useAlert} from "./components/FormComps";
import {mkHref} from "./components/AccountUtils";
import getLogger from "./components/Logging.js"
import './App.css'

const log = getLogger("MemberMakeOwnerDialog")

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

export default function MemberMakeOwnerDialog(props)  {

  const {brandId, api, session:{user}, setBusy} = useSolv()

  const {intl} = useIntlEx()
  const [alert, setAlert] = useAlert()

  const [touched, setTouched] = useState(null)

  // const {data: member, isLoading: memberLoading} = useQuery({
  //   queryFn: createQueryFn(api.getUser, props.userId),
  //   queryKey: ["user", props.userId],
  //   onError: (error) => handleError(error),
  //   enabled: !!props.userId
  // })
  //
  // useEffect(() => {
  //   setBusy(memberLoading ? intl.msg("loading") : null)
  // }, [memberLoading])

  async function handleMakeOwnerClick() {

    try {

      setBusy(intl.msg("working"))

      const {data} = await api.makeOwner(props.tenant.tenantId, props.row.userId)

      window.location = mkHref({suffix: `/members`, tenant: props.tenant, user: user})

    }
    catch (error) {
      log.error("Validation error: ", error)
      handleError(error)
    }
    finally {
      setBusy(null)
    }
  }


  function handleOpenDialog() {
    setAlert(null)
    setTouched(false)
  }

  function handleCloseDialog() {
    closeDialog("dlg_member_make_owner")
  }

  function handleError(error) {
    if (error && error.code) {
      // log.debug("handleError", error.code)
      const code = error.code
      const details = error.details
      switch (code) {
        case "BANNED_INVITER":
          setAlert({type: "error", text: intl.msg("error_banned_user", details)})
          break
        case "UNKNOWN_INVITER":
        case "INVALID_INVITER":
          setAlert({type: "error", text: intl.msg("invite_error_invalid_inviter", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        case "DUPLICATE_INVITEE_USER":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_user", details), field: "inp_emailAddresses", constraint: "unique"})
          break
        case "DUPLICATE_INVITEE_TENANT":
          setAlert({type: "error", text: intl.msg("invite_error_duplicate_tenant", details), field: "inp_tenantName", constraint: "unique"})
          break
        case "BANNED_EMAIL_ADDRESS":
          setAlert({type: "error", text: intl.msg("error_banned_email_address", details), field: "inp_emailAddresses", constraint: "valid"})
          break
        default:
          setAlert({type: "error", text: intl.msg("error_failed", details)})
          break
      }
    }
    else {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  return (

    props?.tenant && props?.row &&
      <>

        <ModalDialog
          dialogId="dlg_member_make_owner"
          size="lg"
          keyboard="true"
          backdrop="static"
          onOpen={handleOpenDialog}
          onClose={handleCloseDialog}>

          <ModalDialog.Header
            title={intl.msg("member_make_owner_title")}
            description={intl.msg("member_make_owner_description")}
            alert={alert}
          />

          {
            !alert &&
              <ModalDialog.Body>
                <Alert alert={{type: "warning", text: intl.msg("member_make_owner_confirm_text", {displayName: props?.row?.displayName, tenantName: props?.tenant?.tenantName})}}/>
              </ModalDialog.Body>
          }

          <ModalDialog.Footer>
            <ModalDialog.Footer.Controls>
              <ActionButton text={intl.msg("make_owner")} icon="owner" flavor="primary" confirm={intl.msg("confirm_make_owner")} onClick={handleMakeOwnerClick}/>
              <ActionButton name="cancel" onClick={handleCloseDialog}/>
            </ModalDialog.Footer.Controls>
          </ModalDialog.Footer>

        </ModalDialog>

      </>
  )
}